import { Base } from "../../framework/base";
import { IdTitleNode, IIdTitleNode } from "../common/idTitleNode";
import { IRecordUnit, RecordUnit } from "../unit/recordUnit";
import { IRiskTemplateEditItem, RiskTemplateEditItem } from "./riskTemplateEditItem";

export interface IRiskTemplateEdit {
    item: IRiskTemplateEditItem;
    riskTemplateUnits: IRecordUnit[];
    units: IIdTitleNode[];
    riskCategories: IIdTitleNode[];
}

export class RiskTemplateEdit implements IRiskTemplateEdit {
    item: RiskTemplateEditItem;
    riskTemplateUnits: RecordUnit[];
    units: IdTitleNode[];
    riskCategories: IdTitleNode[];
    
    constructor();
    constructor(obj: IRiskTemplateEdit);
    constructor(obj?: any) {
        this.item = new RiskTemplateEditItem(obj?.item);
        this.riskTemplateUnits = Base.getTypedArray(obj?.riskTemplateUnits, RecordUnit);
        this.units = Base.getTypedArray(obj?.units, IdTitleNode);
        this.riskCategories = Base.getTypedArray(obj?.riskCategories, IdTitleNode);
    }
}